const LinkedinIcon = ({ color = '#fff', width = '22', height = '22', className }) => {

    return (
        <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="3" width="18" height="18" rx="4" stroke={color} strokeWidth="1.7" />
            <line x1="7.5" y1="10.2" x2="7.5" y2="17" stroke={color} strokeWidth="1.7" strokeLinecap="round" />
            <circle cx="7.5" cy="7" r="0.9" fill={color} />
            <line x1="11.5" y1="10.2" x2="11.5" y2="17" stroke={color} strokeWidth="1.7" strokeLinecap="round" />
            <path d="M11.5 13.3c0-1.7.9-2.7 2.1-2.7 1.2 0 1.9.9 1.9 2.7V17" stroke={color} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )

};

export default LinkedinIcon;
